import type { Accordion } from "~/core";

export const isAccordionBlock = (item: unknown): item is Accordion => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "accordion"
  );
};
